import useCreateAccountApi from "../hooks/use.create.account.api";
import useCreateAccountData from "../hooks/use.create.account.data";
import useFindAccountApi from "../hooks/use.find.account.api";
import useGlobal from "../hooks/use.global";
import { useInflightTracker } from "../hooks/use.inflight.tracker";
import useLoginApi from "../hooks/use.login.api";
import useUnlockAccountApi from "../hooks/use.unlock.account.api";
import useUnlockAccountData from "../hooks/use.unlock.account.data";
import useVerifyAccountApi from "../hooks/use.verify.account.api";

interface Use {
    createAccountApi: ReturnType<typeof useCreateAccountApi> | null
    createAccountData: ReturnType<typeof useCreateAccountData> | null
    global: ReturnType<typeof useGlobal> | null
    loginApi: ReturnType<typeof useLoginApi> | null
    findAccountApi: ReturnType<typeof useFindAccountApi> | null
    inflightTracker: ReturnType<typeof useInflightTracker> | null
    unlockAccountApi: ReturnType<typeof useUnlockAccountApi> | null
    unlockAccountData: ReturnType<typeof useUnlockAccountData> | null
    verifyAccountApi: ReturnType<typeof useVerifyAccountApi> | null
}

const use: Use = {
    createAccountApi: null,
    createAccountData: null,
    global: null,
    loginApi: null,
    findAccountApi: null,
    inflightTracker: null,
    unlockAccountApi: null,
    unlockAccountData: null,
    verifyAccountApi: null
};

export default use;
